import Papa from 'papaparse';

export interface ParseCsvResult {
  headers: string[];
  rows: string[][];
}

export interface ParseCsvError {
  message: string;
}

export function parseCsv(content: string): ParseCsvResult | ParseCsvError {
  const result = Papa.parse<string[]>(content, {
    skipEmptyLines: true,
  });

  if (result.errors.length > 0) {
    return {
      message: result.errors[0].message ?? 'Failed to parse CSV content',
    };
  }

  const data = result.data;
  if (!data || data.length === 0) {
    return { headers: [], rows: [] };
  }

  const headers = data[0];
  const rows = data
    .slice(1)
    .filter((row) => row.some((cell) => String(cell).trim() !== ''));

  return { headers, rows };
}
